/**
 * @file index.tsx
 *
 * @fileoverview Renders a herow with a search banner.
 */

import React from 'react';
import { ParagraphCallToActionBanner } from '~/jobiqo/models/entity';
import { Image } from '~/jobiqo/components/Image';
import { HeroRow } from '~/vcl/organisms/04-landingpage/02-hero-row';
import { Main } from '~/vcl/atoms/06-layout/09-main';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';

export interface CallToActionProps {
  rowBanner: ParagraphCallToActionBanner;
  maxContainerSize?: 'small' | 'medium' | 'large' | 'xLarge';
  index?: number;
}

export const CallToAction = ({
  rowBanner,
  maxContainerSize,
  index = 0,
}: CallToActionProps) => {
  return (
    <HeroRow
      image={
        rowBanner?.callToActionImage?.url ? (
          <Image
            src={rowBanner.callToActionImage.url}
            alt={
              rowBanner.callToActionImage.alt
                ? rowBanner.callToActionImage.alt
                : ''
            }
            title={
              rowBanner.callToActionImage.title
                ? rowBanner.callToActionImage.title
                : ''
            }
            width={null}
            height={null}
            priority={index === 0}
          />
        ) : null
      }
    >
      <Main {...(maxContainerSize ? { size: maxContainerSize } : null)}>
        <WYSIWYGText format="full_html" content={rowBanner.callToActionText} />
      </Main>
    </HeroRow>
  );
};
export default CallToAction;
